module.exports = __webpack_public_path__ + "static/media/Risorsa 014.54ea342d.svg";